import Vue from "vue";

import _Orders from "./Orders";

export const Orders = Vue.component("orders", _Orders);
